const logoEmpresas = {
  title: 'Estas empresas necesitan tu talento',
  linkEmpresas: 'Ver todas las empresas',
}

export default logoEmpresas
